<template>
    <div class="yarnboard">
        <VideoContainer :clip="clip" :nextRoute="nextRoute" />
    </div>
</template>

<script>
import VideoContainer from '@/components/VideoContainer.vue'
import Clip from '@/assets/BLITZ.mp4'

export default {
    name: 'blitz-video',
    components: {
        VideoContainer
    },
    data() {
        return {
            clip: Clip,
            nextRoute: "/woody-steale"
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
